import SimpleIntegerCard from "@/components/cards/SimpleIntegerCard.vue";
import CircularProgressCard from "@/components/cards/CircularProgressCard.vue";
import PieChartComponent from "@/components/charts/PieChartComponent.vue";
import LineChartComponent from "@/components/charts/LineChartComponent.vue";
import KeyValuePairCard from "@/components/cards/KeyValuePairCard.vue";
import AnomalyBreakdownComponent from "@/components/AnomalyBreakdownComponent.vue";
import DashboardListComponent from "@/components/cards/DashboardListComponent.vue";
import InspectionZoneBreakdownCard from "@/components/cards/dashboard/InspectionZoneBreakdownCard.vue";
import HotSpotSummaryCard from "@/components/cards/dashboard/HotSpotSummaryCard.vue";


const DashboardComponentFactory = {
    getComponent(type){
        const componentMap = {
            SimpleIntegerCard: SimpleIntegerCard,
            PieChart: PieChartComponent,
            LineChart: LineChartComponent,
            CirclularProgressCard: CircularProgressCard,
            KeyValuePairCard: KeyValuePairCard,
            AnomalyBreakdownComponent: AnomalyBreakdownComponent,
            DashboardListComponent: DashboardListComponent,
            InspectionZoneBreakdownCard: InspectionZoneBreakdownCard,
            HotSpotSummaryCard: HotSpotSummaryCard
        };

        return componentMap[type] || null;
    },
};

export default DashboardComponentFactory;